import { useEffect, useState } from "react";
import { postAccount } from "./accountApi";

// Who is logged in, asked of /currentuser once per page load and shared by
// every header that shows the user icon. The server also restores a login
// from the long-lived login cookie here.
let current = null;          // the last answer: {signedin, email, logintype}
let pending = null;          // the request in flight
const listeners = new Set();

const publish = (user) => {
    current = user;
    listeners.forEach((l) => l(user));
};

export const refreshCurrentUser = () => {
    pending = postAccount('/currentuser', {})
        .then((user) => { publish(user); return user; })
        .catch(() => { publish({signedin:false}); return current; })
        .finally(() => { pending = null; });
    return pending;
};

export const logOut = () => postAccount('/currentuser', {logout:true})
    .then(publish)
    .catch(() => publish({signedin:false}));

// null until the server has answered
const useCurrentUser = () => {
    const [user, setUser] = useState(current);
    useEffect(() => {
        listeners.add(setUser);
        if (!current && !pending) refreshCurrentUser();
        return () => listeners.delete(setUser);
    }, []);
    return user;
};

export default useCurrentUser;
